import React, { useMemo, useState, useEffect, useRef, useCallback } from 'react'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_map from 'highcharts/modules/map';
import worldMap from '@highcharts/map-collection/custom/world.geo.json';
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

import "./App.css";

HC_map(Highcharts);

const Reliance = ({ }) => {

	const industryId = window.relianceIndustryId || 1;

	const [originCountries, setOriginCountries] = useState([]);
	const [pa, setPa] = useState([]);
	const [overseasPa, setOverseasPa] = useState([]);
	const [additionalPa, setAdditionalPa] = useState([]);
	const [qms, setQms] = useState([]);
	const [additionalEvidence, setAdditionalEvidence] = useState([]);
	const [productType, setProductType] = useState("");
	const [mapData, setMapData] = useState([]);

	const [selectedCountry, setSelectedCountry] = useState("");
	const [selectedSecondaryCountry, setSelectedSecondaryCountry] = useState("");
	const [selectedDestinationCountry, setSelectedDestinationCountry] = useState(null);
	const [selectedPa, setSelectedPa] = useState("");
	const [selectedOverseasPa, setSelectedOverseasPa] = useState("");
	const [selectedAdditionalPa, setSelectedAdditionalPa] = useState("");
	const [selectedQms, setSelectedQms] = useState("");
	const [selectedAdditionalEvidence, setSelectedAdditionalEvidence] = useState("");
	const [selectedProductType, setSelectedProductType] = useState("");

	const [isLoadingOriginCountries, setIsLoadingOriginCountries] = useState(false);
	const [isLoadingAllEvidenceOptions, setIsLoadingAllEvidenceOptions] = useState(false);
	const [isLoadingSearch, setIsLoadingSearch] = useState(false);


	const [hasFiltersApplied, setHasFiltersApplied] = useState(false);
	const [hasCountryAndFiltersApplied, setHasCountryAndFiltersApplied] = useState(false);
	

	const [filterByResultId, setFilterByResultId] = useState(null);
	const [mapDataFilteredByResultId, setMapDataFilteredByResultId] = useState([]);


	const originCountriesRef = useRef([]);


	
	const RESULT_COLORS = {
		1: '#00a000',   // green
		2: '#90ee90',   // light green
		3: '#ff8e2b',    // orange
		4: '#ffff00',   // yellow
		5: '#808080'   // gray
	};

	const ORIGIN_COLOR = '#2caffe';


	// Load origin countries

	useEffect(() => {

		loadOriginCountries();

	}, []);



	// Show Clear filters button when filters are applied

	useEffect(() => {

		if (selectedCountry != "" ||
			selectedPa != "" ||
			selectedOverseasPa != "" ||
			selectedAdditionalPa != "" ||
			selectedQms != "" ||
			selectedAdditionalEvidence != "" ||
			selectedProductType != "")
			setHasFiltersApplied(true);
		else
			setHasFiltersApplied(false);


		if(selectedCountry != "" && 
			selectedPa != "" &&
			selectedQms != "")
			setHasCountryAndFiltersApplied(true);
		else if (selectedCountry != "" && selectedProductType != "")
			setHasCountryAndFiltersApplied(true);
		else
			setHasCountryAndFiltersApplied(false);

	}, [selectedCountry, selectedPa, selectedOverseasPa, selectedAdditionalPa, selectedQms, selectedAdditionalEvidence, selectedProductType]);







	const loadOriginCountries = () => {

		let url = "/umbraco/api/RegulatoryReliance/OriginCountries?industryId=" + industryId;

		const requestOptions = {
            method: "GET",
        };

		setIsLoadingOriginCountries(true);

		fetch(url, requestOptions)
			.then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
			.then((result) => {

				result.sort((a, b) =>
					(a.country_name || '').localeCompare(b.country_name || '', undefined, { sensitivity: 'base' })
				);

				setOriginCountries(result);
				originCountriesRef.current = result;
            })
            .catch((error) => {
                console.log("error: " + error);
            })
			.finally(() => {
				setIsLoadingOriginCountries(false);
            });

	}



	const loadAllEvidenceOptions = (countryId, secondaryCountryId) => {
		
		let url = "/umbraco/api/RegulatoryReliance/AllEvidenceOptions?originCountryId=" + countryId + "&industryId=" + industryId + "&secondaryCountryId=" + secondaryCountryId;

		const requestOptions = {
            method: "GET",
		};

		//setMapData([]);

		setIsLoadingAllEvidenceOptions(true);

		fetch(url, requestOptions)
			.then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

				if (result) {
					setAdditionalEvidence(result.AdditionalEvidence);
					setOverseasPa(result.OverseasPa);
					setPa(result.Pa);
					setQms(result.Qms);
					setAdditionalPa(result.AdditionalPa);
					setProductType(result.ProductType);

					setSelectedAdditionalEvidence("");
					setSelectedOverseasPa("");
					setSelectedPa("");
					setSelectedQms("");
					setSelectedAdditionalPa("");
					setSelectedProductType("");
				}
            })
            .catch((error) => {
                console.log("error: " + error);
            })
			.finally(() => {
				setIsLoadingAllEvidenceOptions(false);
            });


	}



	const changeCountry = (countryId, secondaryCountryId) => {

		if (countryId != "")
			countryId = parseInt(countryId);
		if (secondaryCountryId != "") { 
			secondaryCountryId = parseInt(secondaryCountryId);
			setSelectedSecondaryCountry(secondaryCountryId)
			justShowCurrentCountry(secondaryCountryId);
		}
		setSelectedCountry(countryId);
		setAdditionalEvidence([]);
		setOverseasPa([]);
		setPa([]);
		setQms([]);
		setAdditionalPa([]);
		setProductType([]);
		justShowCurrentCountry(countryId);
		if(countryId != "")
			loadAllEvidenceOptions(countryId, secondaryCountryId);

	}



	const justShowCurrentCountry = (countryId = selectedCountry) => {

		const countryObj = originCountriesRef.current.find(c => c.country_id === countryId);
		if (countryObj) {
			setMapData([{
				origin_country_code: countryObj.country_code_two,
				origin_country: countryObj.country_name,
				destination_country_code: countryObj.country_code_two, // Pointing to itself initially
				destination_country: countryObj.country_name,
				destination_country_flag: countryObj.flag_link,
				destination_country_profile_url: countryObj.country_profile_url,
				result_id: 0, // Custom ID to ensure it's treated as origin
				isOrigin: true
			}]);
		} else {
			setMapData([]);
		}

	}



	const clearFilters = () => {

		changeCountry("", "");

		setSelectedSecondaryCountry("");
		setSelectedAdditionalEvidence("");
		setSelectedOverseasPa("");
		setSelectedPa("");
		setSelectedQms("");
		setSelectedAdditionalPa("");
		setSelectedProductType("");

		//changeCountry(selectedCountry);

	}



	const doSearch = () => {

		if (isLoadingSearch)
			return;

		let url = `/umbraco/api/RegulatoryReliance/Search?
		originCountryId=${selectedCountry}
		&qmsEvidenceId=${selectedQms}
		&productAssessmentId=${selectedPa}
		&additionalEvidenceId=${selectedAdditionalEvidence}
		&industryId=${industryId}
		`;

		if (industryId == 2) {
			url = `/umbraco/api/RegulatoryReliance/PharmaSearch?
		originCountryId=${selectedCountry}
		&secondaryCountryId=${selectedSecondaryCountry}
		&productTypeId=${selectedProductType}
		`;
		}

		//&overseasPaId=${selectedOverseasPa}
		//&additionalPaId=${selectedAdditionalPa}


		const requestOptions = {
            method: "GET",
		};

		setIsLoadingSearch(true);
		setSelectedDestinationCountry(null);

		fetch(url, requestOptions)
			.then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

				if (result && result.length > 0)
					setMapData(result);
				else
					justShowCurrentCountry();
            })
            .catch((error) => {
				console.log("error: " + error);
				justShowCurrentCountry();
            })
			.finally(() => {
				filterByResult(null);
				setIsLoadingSearch(false);
            });



	}



	const callbackChangeCountry = useCallback((key) => {
		const originCountry = originCountriesRef.current.find(
			country =>
				country.country_code_two.toLowerCase() === key.toLowerCase()
		);

		if (originCountry) {
			changeCountry(originCountry.country_id);
		}
	}, [originCountries]);



	const uniqueBy = (array, key) => {
		const seen = new Set();
		return array.filter(item => {
			const value = item[key];
			if (seen.has(value)) return false;
			seen.add(value);
			return true;
		});
	};



	const filterByResult = (resultId) => {

		if (resultId == "all")
			resultId = null;

		setFilterByResultId(resultId);

	}


	useEffect(() => {

		if (filterByResultId == null)
			setMapDataFilteredByResultId(mapData);
		else {
			let filteredMapData = mapData.filter(item => item.result_id == filterByResultId);
			setMapDataFilteredByResultId(filteredMapData);
		}

	}, [mapData, filterByResultId]);





	const [search, setSearch] = useState("");
	const [isOpen, setIsOpen] = useState(false);

	const [secondarySearch, setSecondarySearch] = useState("");
	const [isSecondaryOpen, setIsSecondaryOpen] = useState(false);
	const selectedCountryObj = originCountries.find(
		c => c.country_id == selectedCountry
	);
	const selectedSecondaryCountryObj = originCountries.find(
		c => c.country_id == selectedSecondaryCountry
	);
	// Sync external changes → input display
	useEffect(() => {
		if (selectedCountryObj) {
			setSearch(selectedCountryObj.country_name);
		} else {
			setSearch("");
		}
	}, [selectedCountry, selectedCountryObj]);

	useEffect(() => {
		if (selectedSecondaryCountryObj) {
			setSecondarySearch(selectedSecondaryCountryObj.country_name);
		} else {
			setSecondarySearch("");
		}
	}, [selectedSecondaryCountry, selectedSecondaryCountryObj]);

	const filteredCountries = originCountries.filter(country =>
		country.country_name.toLowerCase().includes(search.toLowerCase())
	);

	const secondaryFilteredCountries = originCountries.filter(country =>
		country.country_name.toLowerCase().includes(secondarySearch.toLowerCase())
	);






	return <>

		<div style={{display: "flex", flexDirection: "column", alignItems: "left", justifyContent: "center", width: "100%", padding: "15px"}}>
			<div style={{ textAlign: "center", marginBottom: "30px" }}>
				<h2 style={{
					fontSize: "1.6rem",
					color: "#333",
					fontWeight: "700",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					gap: "12px"
				}}>
					<i className="fas fa-map-marked-alt" style={{ color: "#0056b3" }}></i>

					<span>
						{/* Dynamic Industry Logic */}
						MedBoard Global Reliance Tool ({industryId === 2 ? "Pharma" : "MedTech"}):

						<span style={{ fontWeight: "400", color: "#666", marginLeft: "10px" }}>
							Instantly plan your next markets
						</span>
					</span>
				</h2>
			</div>


			<div style={{
				display: "flex",
				flexDirection: "row",
				width: "100%",
				gap: "15px",
				alignItems: "stretch"
			}}>

				{/* STEP 1: ORIGIN  */}
				<div
					style={{
						flex: 1,
						padding: "15px",
						border: "1px solid #e0e0e0",
						backgroundColor: "#f8f8f8",
						borderRadius: "8px",
						display: "flex",
						flexDirection: "column",
						position: "relative",
						gap: "12px" // Adds clean spacing between primary and secondary sections
					}}
				>
					{/* PRIMARY ORIGIN SECTION */}
					{/* We wrap this in a relative container so its absolute dropdown anchors perfectly to it */}
					<div style={{ position: "relative", display: "flex", flexDirection: "column" }}>
						<label style={{ fontSize: "0.75rem", color: "#888", marginBottom: "4px" }}>
							1. Evidence Origin *
						</label>

						{/* Input */}
						<input
							type="text"
							placeholder="Select a country or click on the map"
							value={isOpen ? search : (selectedCountryObj?.country_name || "")}
							onFocus={() => {
								setIsOpen(true);
								setSearch("");
							}}
							onChange={(e) => {
								setSearch(e.target.value);
								setIsOpen(true);
							}}
							onBlur={() => {
								setTimeout(() => {
									setIsOpen(false);
								}, 150);
							}}
							style={{
								width: "100%",
								padding: "6px",
								borderRadius: "4px",
								border: "1px solid #ccc",
								boxSizing: "border-box"
							}}
						/>

						{/* Dropdown */}
						{isOpen && (
							<div
								style={{
									position: "absolute",
									top: "100%", // Anchors it right below the input box
									left: 0,
									right: 0,
									maxHeight: "200px",
									overflowY: "auto",
									background: "#fff",
									border: "1px solid #ccc",
									borderRadius: "4px",
									zIndex: 1000,
									marginTop: "4px" // Small gap below input
								}}
							>
								{/* FILTER OUT SECONDARY COUNTRY */}
								{filteredCountries
									.filter(c => c.country_id !== selectedSecondaryCountry)
									.length > 0 ? (
									filteredCountries
										.filter(c => c.country_id !== selectedSecondaryCountry)
										.map(country => (
											<div
												key={country.country_id}
												onMouseDown={(e) => e.preventDefault()}
												onClick={() => {
													changeCountry(country.country_id, selectedSecondaryCountry);
													setSearch(country.country_name);
													setIsOpen(false);
												}}
												style={{
													padding: "6px",
													cursor: "pointer"
												}}
											>
												{country.country_name}
											</div>
										))
								) : (
									<div style={{ padding: "6px", color: "#888" }}>
										No results
									</div>
								)}
							</div>
						)}
					</div>

					{/* SECONDARY ORIGIN (Shows only if industryId == 2) */}
					{industryId === 2 && (
						<div style={{ position: "relative", display: "flex", flexDirection: "column" }}>
							<label
								style={{
									fontSize: "0.75rem",
									color: !selectedCountry ? "#bbb" : "#888", // Dims the text if disabled
									marginBottom: "4px"
								}}
							>
								Additional Origin
							</label>

							{/* Input */}
							<input
								type="text"
								placeholder={selectedCountry ? "Select an additional origin" : "Please select a primary origin first"}
								value={isSecondaryOpen ? secondarySearch : (selectedSecondaryCountryObj?.country_name || "")}
								disabled={!selectedCountry} 
								onFocus={() => {
									setIsSecondaryOpen(true);
									setSecondarySearch("");
								}}
								onChange={(e) => {
									setSecondarySearch(e.target.value);
									setIsSecondaryOpen(true);
								}}
								onBlur={() => {
									setTimeout(() => {
										setIsSecondaryOpen(false);
									}, 150);
								}}
								style={{
									width: "100%",
									padding: "6px",
									borderRadius: "4px",
									border: "1px solid #ccc",
									boxSizing: "border-box",
									backgroundColor: !selectedCountry ? "#eaeaea" : "#fff",
									color: !selectedCountry ? "#888" : "#000"
								}}
							/>

							{selectedCountry && isSecondaryOpen && (
								<div
									style={{
										position: "absolute",
										top: "100%",
										left: 0,
										right: 0,
										maxHeight: "200px",
										overflowY: "auto",
										background: "#fff",
										border: "1px solid #ccc",
										borderRadius: "4px",
										zIndex: 1000,
										marginTop: "4px"
									}}
								>
									{secondaryFilteredCountries
										.filter(c => c.country_id !== selectedCountry)
										.length > 0 ? (
										secondaryFilteredCountries
											.filter(c => c.country_id !== selectedCountry)
											.map(country => (
												<div
													key={country.country_id}
													onMouseDown={(e) => e.preventDefault()}
													onClick={() => {
														changeCountry(selectedCountry, country.country_id);
														setSecondarySearch(country.country_name);
														setIsSecondaryOpen(false);
													}}
													style={{
														padding: "6px",
														cursor: "pointer"
													}}
												>
													{country.country_name}
												</div>
											))
									) : (
										<div style={{ padding: "6px", color: "#888" }}>
											No results
										</div>
									)}
								</div>
							)}
						</div>
					)}
				</div>


				{/* Render this block if industry_id is NOT 2 */}
				{industryId !== 2 && (
					<>
						{/* STEP 2: ASSESSMENT */}
						<div style={{ flex: 1, padding: "15px", border: "1px solid #e0e0e0", backgroundColor: "#f8f8f8", borderRadius: "8px", display: "flex", flexDirection: "column" }}>
							<label style={{ fontSize: "0.75rem", color: "#888", marginBottom: "4px" }}>2. Product Assessment *</label>
							{isLoadingAllEvidenceOptions ? <div style={{ marginTop: "5px" }}>Loading...</div> :
								<select
									style={{ width: "100%", padding: "6px", borderRadius: "4px", border: "1px solid #ccc" }}
									value={selectedPa}
									onChange={(e) => setSelectedPa(e.target.value)}
								>
									{selectedCountry ? <option value="">N/A</option> : <option value="">Select a country first</option>}
									{pa.map((option, index) => (
										<option key={index} value={option.Id}>{option.Name}</option>
									))}
								</select>
							}
						</div>

						{/* STEP 3: QMS GROUP  */}
						<div style={{ flex: 2, padding: "15px", border: "1px solid #e0e0e0", backgroundColor: "#f8f8f8", borderRadius: "8px", display: "flex", flexDirection: "column" }}>
							<div style={{ display: "flex", gap: "10px" }}>
								<div style={{ flex: 1 }}>
									<label style={{ fontSize: "0.75rem", color: "#888", marginBottom: "4px", display: "block" }}>3. QMS *</label>
									{isLoadingAllEvidenceOptions ? <div style={{ marginTop: "5px" }}>Loading...</div> :
										<select
											style={{ width: "100%", padding: "6px", borderRadius: "4px", border: "1px solid #ccc" }}
											value={selectedQms}
											onChange={(e) => setSelectedQms(e.target.value)}
										>
											{selectedCountry ? <option value="">N/A</option> : <option value=""> Select a country first</option>}
											{qms.map((option, index) => (
												<option key={index} value={option.Id}>{option.Name}</option>
											))}
										</select>
									}
								</div>

								<div style={{ flex: 1 }}>
									<label style={{ fontSize: "0.75rem", color: "#888", marginBottom: "4px", display: "block" }}>Additional QMS</label>
									{isLoadingAllEvidenceOptions ? <div style={{ marginTop: "5px" }}>Loading...</div> :
										<select
											style={{ width: "100%", padding: "6px", borderRadius: "4px", border: "1px solid #ccc" }}
											value={selectedAdditionalEvidence}
											onChange={(e) => setSelectedAdditionalEvidence(e.target.value)}
										>
											{selectedCountry ? <option value="">N/A</option> : <option value=""> Select a country first</option>}
											{additionalEvidence.map((option, index) => (
												<option key={index} value={option.Id}>{option.Name}</option>
											))}
										</select>
									}
								</div>
							</div>
						</div>
					</>
				)}

				{/* Render this simple block instead if industry_id IS 2 */}
				{industryId === 2 && (
					<div style={{ flex: 1, padding: "15px", border: "1px solid #e0e0e0", backgroundColor: "#f8f8f8", borderRadius: "8px", display: "flex", flexDirection: "column" }}>
						<label style={{ fontSize: "0.75rem", color: "#888", marginBottom: "4px" }}>Product Type *</label>
						{isLoadingAllEvidenceOptions ? <div style={{ marginTop: "5px" }}>Loading...</div> :
							<select
								style={{ width: "100%", padding: "6px", borderRadius: "4px", border: "1px solid #ccc" }}
								value={selectedProductType}
								onChange={(e) => {
									setSelectedProductType(e.target.value)
									setHasCountryAndFiltersApplied(true)
								}} 
							>
								{selectedCountry ? <option value="">Select a Product Type</option> : <option value="">Select a country first</option>}
								{productType && productType.map((option, index) => (
									<option key={index} value={option.Id}>{option.Name}</option>
								))}
							</select>
						}
					</div>
				)}
			</div>

			{/* ACTIONS SECTION */}
			<div style={{ width: "100%", marginTop: "20px", display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}>
				{!isLoadingAllEvidenceOptions && (
					<>
						{hasCountryAndFiltersApplied ? (
							<button
								onClick={doSearch}
								style={{ padding: "10px 40px", backgroundColor: "#004a99", color: "white", border: "none", borderRadius: "5px", fontWeight: "bold", cursor: "pointer" }}
							>
								SEARCH
							</button>
						) : (
							<span style={{ fontSize: "0.85rem", color: "#999", fontStyle: "italic" }}>
								Please complete all mandatory fields (*) to enable search
							</span>
						)}
					</>
				)}

				{hasFiltersApplied && (
					<button
						onClick={clearFilters}
						style={{ background: "none", border: "none", color: "#b22222", cursor: "pointer", fontSize: "0.85rem", textDecoration: "underline" }}
					>
						Clear all filters
					</button>
				)}
			</div>


			<div style={{marginBottom: "15px"}}>

				{/* Stats */}

				<div style={{display: "flex", flexDirection: "row", marginTop: "20px"}}>
					<div style={{width: "100%", textAlign: "center", minHeight: "55px"}}>
						{mapData && !isLoadingSearch && !isLoadingAllEvidenceOptions ? 
							<ResultSummaryBar data={mapData} resultColors={RESULT_COLORS} filterByResultId={filterByResultId} filterByResultFUNC={filterByResult} />
						: null}
					</div>
				</div>

				{/* Map & other info */}

				<div style={{display: "flex", flexDirection: "row", marginTop: "20px"}}>
					<div style={{ width: "15%", display: "flex", justifyContent: "end" }} >
						<div style={{
							width: "99%",
							padding: "10px",
							borderRadius: "10px",
							backgroundColor: "#f8f8f8"
						}} >

							{mapDataFilteredByResultId.find(country => country.isOrigin == undefined) ? <>
								<div style={{ marginBottom: "15px" }}>Destination countries:</div>
								<div style={{ maxHeight: "440px", overflow: "auto" }}>
									<ul>
										{uniqueBy([...mapDataFilteredByResultId], "destination_country")
											.sort((a, b) => (a.destination_country || '').localeCompare(b.destination_country || '', undefined, { sensitivity: 'base' }))
											.map((item, index) => {
												const isSelected = selectedDestinationCountry === item.destination_country_code;

												return (
													<li
														className={`destination-country-list-item ${isSelected ? 'active' : ''}`}
														key={index}
														onClick={() => setSelectedDestinationCountry(item.destination_country_code)}
													>
														{item.destination_country}
													</li>
												);
											})}
									</ul>
								</div>
							</> : <>
									<div style={{
										textAlign: "center",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
									}}>
									To start select a<br />Country,<br />Product Assessment<br/>and<br />QMS
								</div>
							</>}
						</div>

					</div>
					<div style={{ width: "85%", textAlign: "center", position: "relative" }}>

						{isLoadingSearch || isLoadingAllEvidenceOptions || isLoadingOriginCountries ? 
							<div style={{
									position: "absolute",
									width: "100%",
									height: "100%",
									textAlign: "center",
									backgroundColor: "rgba(1, 1, 1, 0.4)",
									zIndex: "1",
									borderRadius: "15px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
							}}>
								<span style={{width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "10px"}}>
									<LoadingSpinnerImage />
								</span>
							</div>
						: null}

						<>
							{selectedCountry == "" ? 
								<>
									<CountryMapSelector worldMap={worldMap} callbackChangeCountry={callbackChangeCountry} />
								</>
								: 
								<>
									{mapDataFilteredByResultId ? 
										<MapComponent
											data={mapDataFilteredByResultId}
											originalData={mapData}
											resultColors={RESULT_COLORS}
											originColor={ORIGIN_COLOR}
											selectedOriginCountryId={selectedCountry}
											originCountries={originCountries}
											selectedDestinationCountry={selectedDestinationCountry}
											setSelectedDestinationCountry={setSelectedDestinationCountry}
											selectedPa={selectedPa}
											selectedOverseasPa={selectedOverseasPa}
											selectedAdditionalPa={selectedAdditionalPa}
											selectedQms={selectedQms}
											selectedAdditionalEvidence={selectedAdditionalEvidence}
											industryId={industryId}
											selectedSecondaryCountryId={selectedSecondaryCountry }

										/>
									: null}
								</>
							}
						</>
						
					</div>
				
				</div>

			</div>

			
		</div>
		<div style={{ height: "100px" }} ></div>
	</>

}



const MapComponent = ({ data, originalData, resultColors, originColor, selectedOriginCountryId, originCountries, selectedDestinationCountry, setSelectedDestinationCountry, selectedPa = null, selectedOverseasPa = null, selectedAdditionalPa = null, selectedQms = null, selectedAdditionalEvidence = null, industryId = 1, selectedSecondaryCountryId = null
}) => {
  

	const chartRef = useRef();
	const ignoreNextAutomaticFirePointEvent = useRef(false);

	const RESULT_COLORS = resultColors;

	const ORIGIN_COLOR = originColor;


	useEffect(() => {
		if (!selectedDestinationCountry) return;

		const chart = chartRef.current?.chart;
		if (!chart) return;

		const series = chart.series[1];

		const point = series.points.find(
			p => p['hc-key'] === selectedDestinationCountry.toLowerCase()
		);

		series.points.forEach(p => p.setState());

		if (point && !ignoreNextAutomaticFirePointEvent.current) {
			point.setState('hover'); // highlight
			point.firePointEvent('click');
		}

		ignoreNextAutomaticFirePointEvent.current = false;

	}, [selectedDestinationCountry]);




	const mapData = useMemo(() => {

		if (!data || data.length === 0) return [];

		//const originCode = data[0]?.origin_country_code?.toLowerCase();
		//const originName = data[0]?.origin_country;
		//const originCountryFlag = data[0]?.origin_country_flag;

		let originCountry = originCountries.find(item => item.country_id == selectedOriginCountryId);

		const originCode = originCountry?.country_code_two.toLowerCase();
		const originName = originCountry?.country_name;
		const originCountryFlag = originCountry?.flag_link;
		const originCountryUrl = originCountry?.country_profile_url;

		let secondOriginCountry = originCountries.find(item => item.country_id == selectedSecondaryCountryId);
		const secondaryOriginCode = secondOriginCountry?.country_code_two.toLowerCase();
		const secondaryOriginName = secondOriginCountry?.country_name;
		const secondaryOriginCountryFlag = secondOriginCountry?.flag_link;
		const secondaryOriginCountryUrl = secondOriginCountry?.country_profile_url;

		// Group by destination country (keep min result_id)
		const countryMap = {};

		data.forEach(item => {
			const code = item.destination_country_code.toLowerCase();

			if (!countryMap[code]) {
				countryMap[code] = {
					items: [],
					best: item
				};
			}

			countryMap[code].items.push(item);


			Object.values(countryMap).forEach(entry => {
				entry.items.sort((a, b) => a.result_id - b.result_id);
			});


			// track best (lowest result_id)
			if (item.result_id < countryMap[code].best.result_id) {
				countryMap[code].best = item;
			}
		});


		let result = Object.entries(countryMap).map(([code, entry]) => {
			const best = entry.best;

			return {
				'hc-key': code,
				value: best.result_id,
				color: RESULT_COLORS[best.result_id] || '#ccc',

				// keep all information from original data set to show on click popup even when filtered
				allResults: originalData.filter(item => item.destination_country_code.toLowerCase() == code),
				...best
			};
		});


		// Inject origin country if missing
		const originExists = result.some(
			c => c['hc-key'] === originCode
		);
		const secondOriginExists = result.some(
			c => c['hc-key'] === secondaryOriginCode
		);

		if (!originExists && originCode) {
			result.push({
				'hc-key': originCode,
				value: 0,
				color: ORIGIN_COLOR,
				destination_country: originName,
				destination_country_flag: originCountryFlag,
				destination_country_profile_url: originCountryUrl,
				isOrigin: true,
				states: {
					hover: {
						color: ORIGIN_COLOR
					}
				}
			});
		} else {
			// If it exists, force its color to blue
			result = result.map(c =>
				c['hc-key'] === originCode
					? {
						...c,
						color: ORIGIN_COLOR,
						isOrigin: true,
						states: {
							hover: {
								color: ORIGIN_COLOR // <- stays blue on hover
							}
						}
					}
					: c
			);

		}
		if (!secondOriginExists && secondaryOriginCode) {
			result.push({
				'hc-key': secondaryOriginCode,
				value: 0,
				color: ORIGIN_COLOR,
				destination_country: secondaryOriginName,
				destination_country_flag: secondaryOriginCountryFlag,
				destination_country_profile_url: secondaryOriginCountryUrl,
				isOrigin: true,
				states: {
					hover: {
						color: ORIGIN_COLOR
					}
				}
			});
		} else {
			// If it exists, force its color to blue
			result = result.map(c =>
				c['hc-key'] === secondaryOriginCode
					? {
						...c,
						color: ORIGIN_COLOR,
						isOrigin: true,
						states: {
							hover: {
								color: ORIGIN_COLOR // <- stays blue on hover
							}
						}
					}
					: c
			);

		}
		return result;

	}, [data]);



	const options = useMemo(() => ({

		chart: {
			map: worldMap,
			animation: false,
			height: 500,
			events: {
				click: function (e) {
					if (!e.point) {
						// clear popup
						if (this.customPopup) {
							this.customPopup.destroy();
							this.customPopup = null;
						}

						// clear all hover states
						const series = this.series[1];
						series.points.forEach(p => p.setState());

						// Clear selectedDestinationCountry state
						setSelectedDestinationCountry(null);
					}
				}
			}
		},

		legend: {
			enabled: false
		},

		credits: {
			enabled: true,
			text: 'MedBoard.com',
			href: 'https://www.medboard.com',
			mapText: null
		},

		title: {
			text: ''
		},

		tooltip: {
			useHTML: true,
			outside: true, 
			distance: 20,
			padding: 10,
			shadow: true,
			borderRadius: 6,
			style: {
				zIndex: 9999
			},
			formatter: function () {
				if (!this.point.destination_country)
					return false;

				if (this.point.isOrigin) {
					return `

					<div style="font-size:12px; min-width:160px; ">
						<div style="display:flex; align-items:center; justify-content:center; gap:8px; margin-bottom:10px;">
						
						<img
								src="${this.point.destination_country_flag}"
								style="width:18px; object-fit:cover;"
							/>
							<b>${this.point.destination_country}</b>
						</div>
						<div>Origin Country</div>
					</div>

					`;
				}


				// Get evidence information

				let evidenceInformation = "";

				if (selectedQms && selectedQms == this.point.qms_evidence_id && this.point.show_qms == 1)
					evidenceInformation += `<div>${this.point.qms_evidence_name}</div>`;

				if (selectedAdditionalEvidence && selectedAdditionalEvidence == this.point.additional_evidence_id && this.point.show_qms == 1)
					evidenceInformation += `<div>${this.point.additional_evidence_name}</div>`;

				if (selectedPa && selectedPa == this.point.product_assessment_id && this.point.show_pa == 1)
					evidenceInformation += `<div>${this.point.product_assessment_name}</div>`;

				//if (selectedOverseasPa && selectedOverseasPa == this.point.overseas_pa_id)
				if (this.point.overseas_pa_id && this.point.show_pa == 1)
					evidenceInformation += `<div>${this.point.overseas_pa_name}</div>`;

				//if (selectedAdditionalPa && selectedAdditionalPa == this.point.additional_pa_id)
				if (this.point.additional_pa_id && this.point.show_pa == 1)
					evidenceInformation += `<div>${this.point.additional_pa_name}</div>`;

				let evidenceBlock = `<div>${evidenceInformation}</div>`;


				return `

					<div style="font-size:12px; min-width:220px; ">
						<div style="display:flex; align-items:center; gap:8px; margin-bottom:10px;">
						
							<img
							src="${this.point.destination_country_flag}"
							style="width:18px; object-fit:cover;"
							/>
							<b>${this.point.destination_country}</b>
						</div>
						<div style="margin-bottom:6px">
							<span style="
							display:inline-block;
							width:8px;
							height:8px;
							border-radius:50%;
							background:${RESULT_COLORS[this.point.result_id]};
							margin-right:6px;
							"></span>
							<b>${this.point.result}</b> (${this.point.status_name})
							<br/>
							<div style="padding-left: 25px; font-size: 9pt; margin-top: 2px">
								${evidenceBlock}
							</div>
						</div>
					</div>

				`;
			}
		},

		plotOptions: {
			series: {
				cursor: 'pointer',
				animation: false,
				states: {
					hover: {
						enabled: true
					}
				},
				point: {
					events: {
						click: function (e) {

							e.stopPropagation?.();

							const chart = chartRef.current.chart;

							// Remove existing popup
							if (chart.customPopup) {
								const oldPopup = chart.customPopup;
								chart.customPopup = null;

								setTimeout(() => {
									oldPopup.destroy();
								}, 0);
							}

							setSelectedDestinationCountry(null);

							const point = this;

							if (point.isOrigin) {
								// Clear possible highlight
								const series = chart.series[1];
								series.points.forEach(p => p.setState());
								return;
							}

							const countryCode = point.destination_country_code;
							const countryId = point.destination_country_id;


							if (!countryCode || !countryId)
								return;

							ignoreNextAutomaticFirePointEvent.current = true;

							setSelectedDestinationCountry(countryCode);

							const pos = chart.mapView.projectedUnitsToPixels({
								x: point._midX,
								y: point._midY
							});

							if (!pos) return;

							// Track current popup country (for race condition)
							chart.currentPopupCountry = countryCode;
							chart.currentPopupCountryId = countryId;

							const popupId = `popup-${countryCode}-${Date.now()}`;

							// 1. SHOW LOADING POPUP ----

							const fullWidth = chart.chartWidth - 20; // minus margin
							const fullHeight = chart.chartHeight - 20; // minus margin

							const popup = chart.renderer.label(
								`
								<div id="${popupId}" style="width: ${fullWidth}px; max-width: ${fullWidth}px; height: ${fullHeight}px; max-height: ${fullHeight}px; padding: 6px; ">

									<div class="popup-close" style="
										position:absolute;
										top:4px;
										right:24px;
										cursor:pointer;
										font-weight:bold;
									">✕
									</div>

									<div style="display:flex; align-items:center; justify-content: center; gap:8px; margin-bottom:10px;">
								<a target="_blank"  style="cursor: pointer;"  href="${point.destination_country_profile_url}">
								<img
											src="${point.destination_country_flag}"
											style="width: auto;height: 21px;float: inline-start;margin-right: 10px; object-fit:cover;"
										/>
										<b style="font-size:1.5rem">${point.destination_country}</b>
										</a>
									</div>
									<div style="display:flex; align-items:center; justify-content:center; gap:8px;">
										<span>Loading...</span>
									</div>
								</div>
								`,
								pos.x + 10,
								pos.y - 10,
								'rect',
								null,
								null,
								true
							)
								.css({ color: '#000', padding: '10px' })
								.attr({
									fill: '#fff',
									stroke: '#333',
									'stroke-width': 1,
									r: 6,
									zIndex: 9999
								})
								.shadow(true)
								.add();

							chart.customPopup = popup;




							attachPopupEvents(popupId);


							// 2. FETCH DATA ----


							// MEDTECH

							if (industryId == 1) {

								fetch(`/umbraco/api/RegulatoryReliance/DestinationCountryClasses/?destinationCountryId=${countryId}&industryId=${industryId}`)
									.then(res => res.json())
									.then(data => {

										// Prevent race condition
										if (chart.currentPopupCountry !== countryCode) return;


										const getBestResultForCountryClass = (countryId, className) => {

											let rows = originalData
												.filter(item => item.destination_country_id == countryId && item.destination_class == className)
												.sort((a, b) => a.result_id - b.result_id);

											if (rows.length)
												return rows[0];

											return null;
										}

										const getAdditionalEvidenceForCountryClass = (countryId, className) => {
											let rows = originalData.filter(item =>
												item.destination_country_id == countryId &&
												item.destination_class == className &&
												item.additional_evidence_id != null &&
												item.origin_country_id == 1
											);
											if (rows.length)
												return rows[0];

											return null;
										};


										let rows;
										let cols;

									
										cols = `
											<th style="padding: 4px; font-weight: 600;">Destination Classes</th>
											<th style="padding: 4px; font-weight: 600;">Reliance Level</th>
											<th style="padding: 4px; font-weight: 600;">Product Assessment</th>
											<th style="padding: 4px; font-weight: 600;">QMS</th>
											`;

										rows = data
											.map(classItem => {
											const bestResult = getBestResultForCountryClass(countryId, classItem.Name);
											const dotColor = bestResult ? RESULT_COLORS[bestResult.result_id] : '#888';
											const className = classItem.Name;
											const additionalEvidenceForCountryClass = getAdditionalEvidenceForCountryClass(countryId, classItem.Name);
											if (!bestResult) {
												return `
												<tr style="border-bottom: 1px solid #eee;">
													<td style="padding: 8px 4px;">
														${className}
													</td>
													<td style="padding: 8px 4px;"><span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:${dotColor}; margin-right:6px;"></span>
													No reliance</td>
													<td style="padding: 8px 4px;">-</td>
													<td style="padding: 8px 4px;">-</td>
												</tr>`;
											}

											const status = bestResult.result
												? `${bestResult.result} (${bestResult.status_name})`
												: 'No reliance';
											// --- Logic for QMS Column ---
											let qmsContent = "";
											if (selectedQms && selectedQms == bestResult.qms_evidence_id && bestResult.show_qms == 1)
												qmsContent += `<div>${bestResult.qms_evidence_name}</div>`;
											if (selectedAdditionalEvidence && selectedAdditionalEvidence == bestResult.additional_evidence_id && bestResult.show_qms == 1) {
												qmsContent += `<div>${bestResult.additional_evidence_name}</div>`;
												if (additionalEvidenceForCountryClass && additionalEvidenceForCountryClass.additional_evidence_name != bestResult.additional_evidence_name)
													qmsContent += `<div>${additionalEvidenceForCountryClass.additional_evidence_name}</div>`;
											}
											else if (additionalEvidenceForCountryClass && bestResult.show_qms == 1)
												qmsContent += `<div>${additionalEvidenceForCountryClass.additional_evidence_name}</div>`;

											// --- Logic for PA Column ---
											let paContent = "";
											if (selectedPa && selectedPa == bestResult.product_assessment_id && bestResult.show_pa == 1)
												paContent += `<div>${bestResult.product_assessment_name}</div>`;
											if (bestResult.overseas_pa_id && bestResult.show_pa == 1)
												paContent += `<div>${bestResult.overseas_pa_name}</div>`;
											if (bestResult.additional_pa_id && bestResult.show_pa == 1)
												paContent += `<div>${bestResult.additional_pa_name}</div>`;

											return `
												<tr style="border-bottom: 1px solid #eee;">
													<td style="padding: 8px 4px;">
												
														${className}
													</td>
													<td style="padding: 8px 4px;"><span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:${dotColor}; margin-right:6px;"></span>
													${status}</td>
													<td style="padding: 8px 4px;">${paContent}</td>
													<td style="padding: 8px 4px;">${qmsContent}</td>
												</tr>
											`;
										}).join('');


									
										// 3. UPDATE POPUP ----


									
										popup.attr({
												text: `
											<div id="${popupId}" style="width: ${fullWidth}px; max-width: ${fullWidth}px; height: ${fullHeight}px; max-height: ${fullHeight}px; padding: 6px; overflow-y: auto; font-family: sans-serif;">

												<div class="popup-close" style="position:absolute; top:4px; right:24px; cursor:pointer; font-weight:bold;">✕</div>

												<div style="display:flex; align-items:center; justify-content: center; gap:8px; margin-bottom:15px;margin-top:5px">
													<a target="_blank" style="cursor: pointer;" href="${point.destination_country_profile_url}"><img src="${point.destination_country_flag}" style="width: auto;height: 21px;float: inline-start;margin-right: 10px;"/>
													<b style="font-size: 1.5rem;">${point.destination_country}</b></a>
												</div>

												<div style="padding: 0 15px;">
													<div style="margin-bottom: 10px; font-weight: bold; border-bottom: 2px solid #333; display: inline-block;">Reliance Pathways</div>
        
													<table style="width: 100%; border-collapse: collapse; font-size: 9pt; text-align: left;">
														<thead>
															<tr style="border-bottom: 1px solid #ccc; color: #666;">
																${cols}
															</tr>
														</thead>
														<tbody>
															${rows}
														</tbody>
													</table>
												</div>

												<div style="margin-top:20px; text-align:center;">
													<button class="load-more-btn" style="padding:6px 12px; cursor:pointer; border:1px solid #ccc; border-radius:4px; background:#f5f5f5; font-size: 0.85em;">
														Show Reliance Summary
													</button>
												</div>

												<div class="extra-content" style="margin-top:20px; padding: 0 15px;"></div>
											</div>
	`
											});
									

									})
									.catch((ex) => {
										console.log(ex);

										if (!popup)
											return;

										popup.attr({
											text: `
											<div id="${popupId}" style="min-width:220px; padding: 6px; text-align:center">
											
												<div class="popup-close" style="
													position:absolute;
													top:4px;
													right:24px;
													cursor:pointer;
													font-weight:bold;
												">✕
												</div>

												<div style="display:flex; align-items:center; justify-content: center; gap:8px; margin-bottom:10px; font-size:1.5rem">
													<a target="_blank" style="cursor: pointer;"  href="${point.destination_country_profile_url}"><img
														src="${point.destination_country_flag}"
														style="width: auto;height: 21px;float: inline-start;margin-right: 10px; object-fit:cover;"
													/>
													<b style="font-size:1.5rem">${point.destination_country}</b></a>
												</div>
												<div style="margin-top:10px; color:red;">
													Failed to load data
												</div>
											</div>
											`
										});
									})
									.finally(() => {
										attachPopupEvents(popupId);
									});

							}


							// PHARMA

							if (industryId == 2) {
								const mainRowLabels = [
									"Product Type Description*",
									"Reliance Route:",
									"Required Documentation:",
									"GMP Reliance (Waiver of GMP Inspection):"
								];

								const additionalRowLabels = [
									"CMC Considerations",
									"Clinical Trial",
									"Reliance Availability"
								];

								const stickyHeaderStyle = "position: sticky; top: 0; z-index: 5; border-bottom: 1px solid #ccc; padding: 8px 6px; white-space: normal; word-wrap: break-word; vertical-align: bottom;";

								let cols = `<th class="pharma-reliance-details-header" style="${stickyHeaderStyle} min-width: 140px; max-width: 200px;">Reliance Level</th>`;
								let rows = "";
								let infoCol = [];

								const result = originalData.filter(item => item.destination_country_id == countryId);
								const seenStatuses = new Set();

								result.forEach(item => {
									if (!seenStatuses.has(item.status_name)) {
										seenStatuses.add(item.status_name);

										cols += `<th class="pharma-reliance-details-header" style="${stickyHeaderStyle} min-width: 150px; max-width: 250px;">${item.status_name}</th>`;

										infoCol.push([
											item.description_product_type,
											item.criteria,
											item.required_documentation,
											item.gmp_reliance,
											item.cmc_stability_studio,
											item.clinical_trial_req,
											item.timeframe_days,
										]);
									}
								});

								const cellStyle = "padding: 8px 6px; white-space: normal; word-wrap: break-word; vertical-align: top; border-bottom: 1px solid #eee;";

								mainRowLabels.forEach((label, i) => {
									rows += `<tr class="pharma-reliance-details-row ${i % 2 === 0 ? 'odd' : ''}">`;
									rows += `<td style="font-weight: bold; max-width: 200px; ${cellStyle}">${label}</td>`;
									rows += infoCol.map(item => `<td style="max-width: 250px; ${cellStyle}">${item[i] || '-'}</td>`).join('');
									rows += `</tr>`;
								});

								rows += `
<tr>
    <td colspan="${infoCol.length + 1}" class="pharma-reliance-details-header" style="padding: 12px 6px 6px 6px; font-weight: bold; border-bottom: 1px solid #ccc; border-top: 1px solid #ccc; text-align: left;">
        Additional Requirements/Considerations
    </td>
</tr>`;

								additionalRowLabels.forEach((label, index) => {
									let i = index + 4;
									rows += `<tr class="pharma-reliance-details-row ${i % 2 === 0 ? 'odd' : ''}">`;
									rows += `<td style="font-weight: bold; max-width: 200px; ${cellStyle}">${label}</td>`;
									rows += infoCol.map(item => `<td style="max-width: 250px; ${cellStyle}">${item[i] || '-'}</td>`).join('');
									rows += `</tr>`;
								});

								if (!popup) return;

								if (infoCol.length === 0) {
									popup.attr({
										text: `
    <div id="${popupId}" style="width: 250px; padding: 15px; text-align: center; font-family: sans-serif; box-sizing: border-box;">
        <div class="popup-close" style="position: absolute; top: 8px; right: 15px; cursor: pointer; font-weight: bold; font-size: 1.2rem;">✕</div>
        <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 10px;">
            <a target="_blank" style="cursor: pointer; text-decoration: none; color: inherit; display: flex; align-items: center; gap: 8px;" href="${point.destination_country_profile_url}">
                <img src="${point.destination_country_flag}" style="height: 21px; width: auto; object-fit: cover;" alt="flag" />
                <b style="font-size: 1.5rem; margin: 0;">${point.destination_country}</b>
            </a>
        </div>
        <!-- Reverted color to standard red -->
        <div style="margin-top: 15px; color: red; font-weight: bold;">
            No reliance pathways found.
        </div>
    </div>`
									});
							} else {
								popup.attr({
									text: `
    <div id="${popupId}" style="
        width: ${fullWidth}px; 
        max-width: 90vw; 
        padding: 15px; 
        font-family: sans-serif; 
        box-sizing: border-box;
        position: relative;
    ">
        <div class="popup-close" style="position: absolute; top: 8px; right: 15px; cursor: pointer; font-weight: bold; font-size: 1.2rem; z-index: 10;">✕</div>

        <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 10px; padding-right: 20px;">
            <a target="_blank" style="cursor: pointer; text-decoration: none; color: inherit; display: flex; align-items: center; gap: 8px;" href="${point.destination_country_profile_url}">
                <img src="${point.destination_country_flag}" style="height: 21px; width: auto; object-fit: cover;" alt="flag" />
                <b style="font-size: 1.5rem; margin: 0;">${point.destination_country}</b>
            </a>
        </div>

        <div style="margin-bottom: 10px; font-weight: bold; border-bottom: 2px solid #333; display: inline-block;">Reliance Pathways</div>
        
        <div style="
            display: block;
            width: 100%; 
            max-height: 350px; 
            overflow: auto; 
            border: 1px solid #ccc; 
            border-radius: 4px;
        ">
            <table style="
                width: 100%; 
                min-width: 500px; 
                border-collapse: separate; 
                border-spacing: 0; 
                font-size: 0.85rem; 
                text-align: left; 
                margin: 0;
            ">
                <thead>
                    <tr>
                        ${cols}	
                    </tr>
                </thead>
                <tbody>
                    ${rows}
                </tbody>
            </table>

            <div style="margin-top: 15px; margin-bottom: 15px; text-align: center;">
                <button class="load-more-btn" style="padding: 8px 16px; cursor: pointer; border: 1px solid #ccc; border-radius: 4px; background: #f5f5f5; font-size: 0.9rem;">
                    Show Reliance Summary
                </button>
            </div>

            <div class="extra-content" style="margin-top:20px; padding: 0 15px 15px 15px;"></div>
        </div>
    </div>`
								});
							}
							}




						},

						mouseOver: function () {
							if (this.isOrigin) {
								this.update(
									{ color: ORIGIN_COLOR },
									false
								);
							}
						}
					}
				}
			}
		},

		series: [
			{
				name: 'Basemap',
				mapData: worldMap,
				borderColor: '#ccc',
				nullColor: '#f0f0f0',
				showInLegend: false,
			},
			{
				name: 'Countries',
				data: mapData,
				joinBy: 'hc-key',
				states: {
					hover: {
						//color: '#a4edba'
					}
				},
				dataLabels: {
					enabled: false
				},
			}
		],

		mapNavigation: {
			enabled: true,
			enableButtons: true,
			enableMouseWheelZoom: true,
			enableDoubleClickZoom: true,
			buttonOptions: {
				verticalAlign: 'bottom'
			}
		},

	}), [mapData]);


	// Popup events for X closing, wheel scrolling, click, etc

	const attachPopupEvents = (popupId) => {

		setTimeout(() => {

			if (!chartRef.current)
				return;

			const chart = chartRef.current.chart;
			const container = chart.container.querySelector(`#${popupId}`);
			const closeBtn = container?.querySelector('.popup-close');
			const loadMoreBtn = container?.querySelector('.load-more-btn');
			const extraContent = container?.querySelector('.extra-content');

			// Clicking/Scrolling on the popup doesn't propagate the click/scroll to the chart (that would close it/zoom it)
			if (container) {
				container.addEventListener('click', (e) => { e.stopPropagation(); });
				container.addEventListener('wheel', (e) => { e.stopPropagation(); });


				//container.addEventListener('mousemove', (e) => { e.stopPropagation(); });
				//container.addEventListener('mousedown', (e) => { e.stopPropagation(); });
				//container.addEventListener('mouseup', (e) => { e.stopPropagation(); });

			}

			
			if (closeBtn) {
				closeBtn.onclick = () => {

					if (chart.customPopup) {
						chart.customPopup.destroy();
						chart.customPopup = null;
					}

					// reset selected destination country state
					setSelectedDestinationCountry(null);

					// clear highlight
					const series = chart.series[1];
					series.points.forEach(p => p.setState());
				};
			}

			

			if (loadMoreBtn) {
				loadMoreBtn.onclick = async () => {

					// prevent duplicate loads
					if (loadMoreBtn.dataset.loaded === "true") return;
					loadMoreBtn.dataset.loaded = "true";

					loadMoreBtn.innerText = "Loading summary...";
					loadMoreBtn.disabled = true;

					try {
						const res = await fetch(`/umbraco/api/RegulatoryReliance/SummaryReliance/?countryId=${chart.currentPopupCountryId}&industryId=${industryId}`);
						const data = await res.json();


						let html = `<div>${data.text}</div>`;


						if (data.evidence_link != "") {

							let links = data.evidence_link.split("|");

							html += `<div style="font-size: 11px">References:`;

							html += `<div style="margin-left: 15px; max-width: 100%; margin-top: 5px">`;

							links.map(link => {

								html += `<div style="
											overflow:hidden;
											white-space:nowrap;
											text-overflow:ellipsis;
											margin-bottom:6px;
										  ">- <a href=${link} target="_blank">${link}</a>
										  </div>`;
							});

							html += `</div></div>`;

						}

						html = "<div>" + html + "</div>";

						if (extraContent) {
							extraContent.innerHTML += html;
						}

						loadMoreBtn.innerText = "Summary";

					} catch (err) {
						loadMoreBtn.innerText = "Failed";

						// allow retry if it failed
						loadMoreBtn.dataset.loaded = "false";
						loadMoreBtn.disabled = false;
					}
				};
			}




		}, 0);

	}


	

	// Close popup on change mapData
	useEffect(() => {
		const chart = chartRef.current?.chart;
		if (!chart) return;

		if (chart.customPopup) {
			chart.customPopup.destroy();
			chart.customPopup = null;
		}
	}, [mapData]);




	return (
		<div style={{ display: 'flex' }}>
		  <div style={{ width: '100%' }}>
			<HighchartsReact
				ref={chartRef}
				highcharts={Highcharts}
				constructorType={'mapChart'}
				options={options}
			/>
		  </div>
		</div>
	);
};





const ResultSummaryBar = ({ data, resultColors, filterByResultId, filterByResultFUNC }) => {
	const RESULT_COLORS = resultColors;


	const getUniqueCountriesWithBestResult = (data) => {
		const map = {};

		data.forEach(item => {
			const c = item.destination_country_id;
			if (!c || !item.result_id) return;

			if (!map[c] || item.result_id < map[c].result_id) {
				map[c] = item;
			}
		});

		return Object.values(map);
	};



	const getResultSummary = (data) => {
		const summary = {};

		// Track unique (country + result) combinations
		const seen = new Set();

		data.forEach(item => {
			const countryId = item.destination_country_id;
			const resultId = item.result_id;

			if (!countryId || !resultId) return;

			const key = `${countryId}-${resultId}`;

			// duplicates per country per result
			if (seen.has(key)) return;
			seen.add(key);

			if (!summary[resultId]) {
				summary[resultId] = {
					count: 0,
					label: item.result
				};
			}

			summary[resultId].count++;

		});

		if (Object.entries(summary).length == 0)
			return summary;


		// Count unique countries

		const uniqueCountries = new Set();

		data.forEach(d => {
			if (d.destination_country_id)
				uniqueCountries.add(d.destination_country_id);
		});

		const countUniqueCountries = uniqueCountries.size;

		return {
			all: {
				count: countUniqueCountries,
				label: "All"
			},
			...summary
		};
	};


	const OLDgetResultSummary = (data) => {
		const summary = {};
		let total = 0;

		const filteredData = getUniqueCountriesWithBestResult(data);

		filteredData.forEach(item => {
			const id = item.result_id;

			if (!id) return;

			total++;

			if (!summary[id]) {
				summary[id] = {
					count: 0,
					label: item.result,
				};
			}

			summary[id].count++;
		});

		if (total == 0)
			return summary;

		// add "All"
		return {
			all: {
				count: total,
				label: "All"
			},
			...summary
		};
	};


	const summary = getResultSummary(data);



	const drawFilterBullet = (id, item) => {


		return (
			<div key={id}
				onClick={() => filterByResultFUNC(id)}
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: '8px',
					background: '#f5f5f5',
					padding: '6px 12px',
					borderRadius: '20px',
					fontSize: '13px',
					cursor: 'pointer', // optional if clickable
					border: filterByResultId == id || filterByResultId == null && id == "all" ? "1px solid #666" : "none",
				}}
			>
				{/* colored dot */}
				<span style={{
					width: '10px',
					height: '10px',
					borderRadius: '50%',
					backgroundColor:
						id === 'all'
							? '#333' // special color for All
							: RESULT_COLORS[id] || '#ccc',
					display: 'inline-block'
				}} />

				{/* label */}
				<span>{item.label}</span>

				{/* count */}
				<span style={{
					fontWeight: 'bold',
					marginLeft: '4px'
				}}>
					({item.count})
				</span>

			</div>
		);

	}



	return (


		<div style={{ width: "100%", display: "flex", flexDirection: "row" }} >

			<div style={{ width: "15%", display: "flex", flexDirection: "row" }}>
				
				<div style={{ width: "100%" }}>

					<div style={{
						display: 'flex',
						padding: '10px 0',
						flexWrap: 'wrap',
						justifyContent: 'center'
					}}>
						{Object.entries(summary)
							.filter(([id]) => id === "all")
							.map(([id, item]) => drawFilterBullet(id, item))}
					</div>
				</div>

			</div>

			<div style={{ width: "85%" }}>
				<div style={{
					display: 'flex',
					gap: '16px',
					padding: '10px 0',
					flexWrap: 'wrap',
					justifyContent: 'center'
				}}>
					{Object.entries(summary)
						.filter(([id]) => id !== "all")
						.sort(([a], [b]) => Number(a) - Number(b))
						.map(([id, item]) => drawFilterBullet(id, item))}
				</div>
			</div>

			<div style={{ width: "20%" }}></div>


		</div>

	);
};





const CountryMapSelector = ({ worldMap, callbackChangeCountry }) => {

	const chartRef = useRef(null);

	const selectCountry = (key) => {

		callbackChangeCountry(key);

	}


	const options = useMemo(() => ({
		chart: {
			map: worldMap,
			animation: false,
			height: 500,
		},

		title: {
			text: "Select a country"
		},

		legend: {
			enabled: false
		},

		credits: {
			enabled: true,
			text: 'MedBoard.com',
			href: 'https://www.medboard.com',
			mapText: null
		},

		mapNavigation: {
			enabled: true,
			enableButtons: true,
			enableMouseWheelZoom: true
		},

		tooltip: {
			useHTML: true,
			formatter: function () {
				return this.point.name || "Unknown";
			}
		},

		colorAxis: {
			nullColor: "#f0f0f0"
		},

		series: [
			{
				name: "Countries",
				mapData: worldMap,
				joinBy: "hc-key",
				data: worldMap.features.map(f => ({
					"hc-key": f.properties["hc-key"],
					name: f.properties.name
				})),

				states: {
					hover: {
						//color: "#a4edba"
					}
				},

				dataLabels: {
					enabled: false
				},

				point: {
					events: {
						click: function () {
							selectCountry(this["hc-key"]);
						}
					}
				}
			}
		]
	}), [worldMap]);

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
			{/* MAP */}
			<HighchartsReact
				ref={chartRef}
				highcharts={Highcharts}
				constructorType="mapChart"
				options={options}
			/>

		</div>
	);
};







export default Reliance;